export const REGEX_CODE = /^(?<code>[A-Z]{4})$/
export const MAX_LENGTH_NAME = 24
export const PLAYER_FORWARD_BACKWARD = 20000
export const PLAYER_VOLUME_INC = 10
